import './App.css';

import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';

import DisclaimerPage from './pages/DisclaimerPage';
import GamesPage from './pages/GamesPage';
import HomePage from './pages/HomePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import { ROUTES } from './Routes';
import TermsPage from './pages/TermsPage';
import { useEffect } from 'react';

function ScrollToTopOnRouteChange() {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);
    return null;
}

const App = () => {
    return (
        <Router>
            <ScrollToTopOnRouteChange />
            <Routes>
                <Route path={ROUTES.BASE} element={<HomePage />} />
                <Route path={ROUTES.PRIVACY} element={<PrivacyPolicyPage />} />
                <Route path={ROUTES.TERMS} element={<TermsPage />} />
                <Route path={ROUTES.DISCLAIMER} element={<DisclaimerPage />} />
                <Route path={ROUTES.GAME} element={<GamesPage />} />
            </Routes>
        </Router>
    );
};

export default App;